var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFioAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6_380)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 50,
    height: 50,
    rx: 6.66667,
    fill: "url(#paint0_linear_6_380)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_380)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3987 57.933V68.332C53.3987 68.8847 53.051 69.1487 52.622 68.9148L46.7281 65.6892C46.2519 65.3687 45.9609 64.8348 45.9477 64.2614V54.0981C46.0346 54.1679 46.1253 54.2282 46.2217 54.2811L53.3987 57.933Z",
    fill: "#765CD6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9621 44.7847V45.4056C45.958 45.179 45.958 44.973 45.9621 44.7847Z",
    fill: "#765CD6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3302 38.0479V45.6128C59.3204 46.0917 59.0681 46.461 58.6644 46.7169L55.215 48.5364L54.9629 48.6111L46.5117 44.3604C46.5 44.3527 46.4884 44.3468 46.4767 44.341C46.4457 44.3255 46.4146 44.3158 46.3836 44.3061C46.3622 44.3022 46.3409 44.2964 46.3215 44.2945C46.3021 44.2906 46.2826 44.2906 46.2632 44.2906C46.205 44.2926 46.1487 44.3061 46.0963 44.3294C46.0788 44.3391 46.0614 44.3468 46.0458 44.3585C46.0458 44.3585 46.0458 44.3604 46.042 44.3604L46.0361 44.3662C46.2807 43.9223 46.7562 43.6663 47.4647 43.2863L58.6644 37.5496C59.0293 37.3635 59.3302 37.5787 59.3302 38.0479Z",
    fill: "#765CD6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9869 51.3534V58.8958C58.9869 59.3639 58.6943 59.5822 58.3394 59.3967L46.5197 53.1868C46.2516 53.0146 46.0534 52.7555 45.9477 52.4577C45.9571 52.4731 45.9647 52.4886 45.976 52.5021C45.9836 52.5118 45.9911 52.5215 46.0006 52.5311C46.0024 52.535 46.0043 52.5369 46.0081 52.5408C46.0157 52.5486 46.0232 52.5582 46.0326 52.566C46.0421 52.5776 46.0534 52.5853 46.0647 52.595C46.0817 52.6066 46.0968 52.6182 46.1157 52.6259C46.2271 52.6859 46.3687 52.682 46.5197 52.6027L54.7393 48.2861L55.2523 48.5104L58.3394 50.1737C58.7339 50.4309 58.9775 50.8738 58.9869 51.3534Z",
    fill: "#A08AEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2614 48.5126L46.6333 52.7926C46.4748 52.8712 46.3262 52.8751 46.2093 52.8156C46.1895 52.808 46.1736 52.7964 46.1558 52.7849C46.1439 52.7753 46.132 52.7677 46.1221 52.7562C46.1122 52.7485 46.1042 52.7389 46.0963 52.7313C46.0924 52.7274 46.0904 52.7255 46.0884 52.7216C46.0785 52.7121 46.0706 52.7025 46.0626 52.6929C46.0507 52.6795 46.0428 52.6641 46.0329 52.6488C45.9794 52.5568 45.9477 52.4379 45.9477 52.2998V44.7235C45.9477 44.4972 46.025 44.3285 46.1478 44.2384C46.1498 44.2364 46.1518 44.2345 46.1538 44.2345C46.1538 44.2345 46.1558 44.2307 46.1577 44.2307C46.1736 44.2192 46.1914 44.2115 46.2093 44.2019C46.2628 44.1789 46.3202 44.1655 46.3797 44.1636C46.3995 44.1636 46.4193 44.1636 46.4391 44.1674C46.459 44.1693 46.4808 44.1751 46.5026 44.1789C46.5343 44.1885 46.566 44.1981 46.5977 44.2134C46.6096 44.2192 46.6215 44.2249 46.6333 44.2326L55.2614 48.5126Z",
    fill: "#8B73E2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6_380",
    x: 0,
    y: 0,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_6_380"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_380"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_380",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_380",
    x1: 53.2,
    y1: 28,
    x2: 53.2,
    y2: 53.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE6FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.25,
    height: 31.6667,
    fill: "white",
    transform: "translate(45.9167 37.3335)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFioAppIcon);
export default __webpack_public_path__ + "static/media/fio-app-icon.c5eeedbbabdd6d886ac08a30625a12df.svg";
export { ForwardRef as ReactComponent };